export const PRICE_TYPES = {
  FIX: 'fix',
  FLEX: 'flex',
};
